import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Header, Button, Form as FormUi, Icon, Segment, Container, Dropdown } from 'semantic-ui-react'
import { withFormik, Field as Fieldmik, Form as Formiker } from 'formik'
import ReadAxios from '../axiosComponent/readAxios'
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import { UploadFile } from '../dynamicComponent/uploadFile';
import { isEmpty } from "lodash";
import * as Yup from 'yup';
import { DateData } from '../dynamicComponent/dateData';
import MyVehicleType from '../dynamicComponent/myVehicleType'
import moment from 'moment';
import 'moment-timezone';

var submit_form = true;

const VehicleDetails = ({ values, touched, errors, setFieldValue, openBox, handleClose, mode }) => {

  const [vehicles, setvehicletype] = useState([])

  useEffect(() => {
    getAllFetch();
  }, []);

  const [open, setOpen] = React.useState(false)

  if (submit_form === false) {
    setOpen(false)
    submit_form = true
  }
  let viewPDF = (e, data) => {
    let path = `${process.env.REACT_APP_MAIN_URL}/vendor_onboarding/resource?customerNo=${localStorage.getItem('customerNo')}&resource_url=${data.pdf_value}`
    window.open(path, "_blank");
  }

  const getAllFetch = async () => {
    // console.log("in get fetch all ")

    let [dataArray] = await Promise.all([ReadAxios({ masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/vehicleTypeMaster`, method: "post" })]);
    // console.log("step 1")
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    if (dataArray)
      setvehicletype(
        dataArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.vehicleType,
            value: item.vehicleTypeId,
            raw: { ...item },
          };
        })
      );
  };


  return (
    <div>
      <Modal
        size="large"
        /*eslint-disable*/
        onClose={handleClose}
        open={openBox}
        style={{ overflow: 'inherit' }}

      >
        <Modal.Header className="p-bold-100">
          <h5> Add vehicle details </h5>
        </Modal.Header>
        <Formiker>
          <Container fluid>
            <Segment className="m-3">
              <div className="ui form tiny">
                <FormUi.Group>
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">Vehicle Number *</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} name="vehicleNumber" placeholder="AB01XY1234" maxLength={[11, 'Vehicle number cannot be longer than 11 digits']} />
                    {touched.vehicleNumber && errors.vehicleNumber && <label className="p-10 mt-2 w3-text-red">{errors.vehicleNumber}</label>}
                  </FormUi.Field>
                  <FormUi.Field width={1} />
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">
                      Vehicle Type *
                            </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={
                      touched.vehicleTypeId && errors.vehicleTypeId
                        ? true
                        : false
                    }
                  >
                    <Fieldmik name="vehicleTypeId" value={values.vehicleTypeId} disabled={mode == "edit" ? true : false} readOnly={mode == "edit" ? true : false} component={MyVehicleType} getVehicleType={(data) => {
                      setFieldValue('vehicle_type_name', data.vehicleType)
                    }} />
                    {touched.vehicleTypeId &&
                      errors.vehicleTypeId ? (
                      <div className="w3-small w3-text-red">
                        {errors.vehicleTypeId}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group inline>
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">Dimensions (in FT)</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} placeholder="L* B *H" name="vehicleDimensions" />
                    <div>
                    </div>
                    {touched.vehicleDimensions && errors.vehicleDimensions && <label className="p-10 mt-2 w3-text-red">{errors.vehicleDimensions}</label>}
                  </FormUi.Field>
                  <FormUi.Field width={1} className="ml-2" />
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">Capacity (in MT)</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} name="vehicleCapacity" />
                    {touched.vehicleCapacity && errors.vehicleCapacity && <label className="p-10 mt-2 w3-text-red">{errors.vehicleCapacity}</label>}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group>
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">GPS Partner</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} name="vehicleGps" />
                    {touched.vehicleGps && errors.vehicleGps && <label className="p-10 mt-2 w3-text-red">{errors.vehicleGps}</label>}
                  </FormUi.Field>
                  <FormUi.Field width={1} />
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">Base Location</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} name="vehicleBaseLocation" />
                    {touched.vehicleBaseLocation && errors.vehicleBaseLocation && <label className="p-10 mt-2 w3-text-red">{errors.vehicleBaseLocation}</label>}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group inline>
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">PUC *</label>
                    {touched.vehiclePUCFile &&
                      errors.vehiclePUCFile ? (
                      <div className="w3-small labelName mt-2 ml-2 w3-text-red">
                        {errors.vehiclePUCFile}
                      </div>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} wrapperClassName="inlineDate" icon="calendar" component={DateData} name="vehiclePUCExpiryDate" />
                    {mode === 'edit' ?
                      <Button size="mini" onClick={viewPDF} pdf_value={values.vehiclePUCFile} color="facebook" disabled={values.vehiclePUCFile ? false : true} icon><Icon name="download" /> PDF</Button>
                      :
                      <Fieldmik component={UploadFile} typer={[".pdf"]} clrd="blue" buttonName={values.vehiclePUCFile ? <> PDF <Icon color="green" name="check" /> </> : 'PDF'} name="vehiclePUCFile" />
                    }

                  </FormUi.Field>
                  <FormUi.Field width={1} />
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2 ml-2">Insurance *</label>
                    {touched.vehicleInsuranceFile &&
                      errors.vehicleInsuranceFile ? (
                      <label className="w3-small labelName mt-2 ml-2 w3-text-red">
                        {errors.vehicleInsuranceFile}
                      </label>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} wrapperClassName="inlineDate" icon="calendar" component={DateData} name="vehicleInsuranceExpiryDate" />
                    {mode === 'edit' ?
                      <Button size="mini" onClick={viewPDF} pdf_value={values.vehicleInsuranceFile} color="facebook" disabled={values.vehicleInsuranceFile ? false : true} icon ><Icon name="download" /> PDF</Button> : <Fieldmik component={UploadFile} typer={[".pdf"]} clrd="blue" buttonName={values.vehicleInsuranceFile ? <> PDF <Icon color="green" name="check" /></> : 'PDF'} name="vehicleInsuranceFile" />
                    }

                  </FormUi.Field>
                </FormUi.Group>

                <FormUi.Group inline>
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">Fitness Certificate</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} wrapperClassName="inlineDate" icon="calendar" component={DateData} name="vehicleFitnessCertExpiryDate" />
                    {mode === 'edit' ?
                      <Button size="mini" onClick={viewPDF} pdf_value={values.vehicleFitnessCertFile} color="facebook" disabled={values.vehicleFitnessCertFile ? false : true} icon><Icon name="download" /> PDF</Button>
                      :
                      <Fieldmik component={UploadFile} typer={[".pdf"]} clrd="blue" buttonName={values.vehicleFitnessCertFile ? <>PDF <Icon color="green" name="check" /> </> : 'PDF'} name="vehicleFitnessCertFile" />}
                  </FormUi.Field>
                  <FormUi.Field width={1} />
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2 ml-2">Permit</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} wrapperClassName="inlineDate" icon="calendar" component={DateData} name="vehiclePermitExpiryDate" />
                    {mode === 'edit' ?
                      <Button size="mini" onClick={viewPDF} pdf_value={values.vehiclePermitFile} color="facebook" disabled={values.vehiclePermitFile ? false : true} icon><Icon name="download" /> PDF</Button>
                      :
                      <Fieldmik component={UploadFile} typer={[".pdf"]} clrd="blue" buttonName={values.vehiclePermitFile ? <> PDF <Icon color="green" name="check" /> </> : 'PDF'} name="vehiclePermitFile" />}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group inline>
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">Vehicle RC Number</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} name="vehicleRCNo" />
                    <Fieldmik readOnly={mode == "edit" ? true : false} wrapperClassName="inlineDate" icon="calendar" component={DateData} name="vehicleRCNoExpiryDate" />
                  </FormUi.Field>
                  <FormUi.Field width={1} />
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2 ml-2">Road Tax Validity</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik readOnly={mode == "edit" ? true : false} wrapperClassName="inlineDate" icon="calendar" component={DateData} name="vehicleRoadTaxValidityDate" />
                  </FormUi.Field>
                </FormUi.Group>
              </div>
            </Segment>
            <center>
              {mode !== 'edit' ? <Button type="submit" className="m-2" primary size="mini" >Save</Button> : ''}
              <Button type="button" onClick={handleClose} className="m-2" size="mini" >Cancel</Button></center>
          </Container>
        </Formiker>
      </Modal>
    </div>
  )
}

const VehicleModal = withFormik(
  {
    enableReinitialize: true,
    mapPropsToValues(props) {
      console.log('VEHICLEMODAL', props.vehicleInfo)
      return {
        vehicleNumber: props.vehicleInfo.vehicleNumber && props.mode=='reg_edit' ? props.vehicleInfo.vehicleNumber : '',
        vehicleTypeId: props.vehicleInfo.vehicleTypeId  && props.mode=='reg_edit' ? props.vehicleInfo.vehicleTypeId : '',
        vehicleDimensions: props.vehicleInfo.vehicleDimensions  && props.mode=='reg_edit' ? props.vehicleInfo.vehicleDimensions : '',
        vehicleCapacity: props.vehicleInfo.vehicleCapacity   && props.mode=='reg_edit'? props.vehicleInfo.vehicleCapacity : '',
        vehicleGps: props.vehicleInfo.vehicleGps  && props.mode=='reg_edit' ? props.vehicleInfo.vehicleGps : '',
        vehicleBaseLocation: props.vehicleInfo.vehicleBaseLocation  && props.mode=='reg_edit' ? props.vehicleInfo.vehicleBaseLocation : '',
        vehiclePUCExpiryDate: props.vehicleInfo.vehiclePUCExpiryDate  && props.mode=='reg_edit' ? props.vehicleInfo.vehiclePUCExpiryDate : null,
        vehiclePUCFile: props.vehicleInfo.vehiclePUCFile  && props.mode=='reg_edit' ? props.vehicleInfo.vehiclePUCFile : '',
        vehicleInsuranceExpiryDate: props.vehicleInfo.vehicleInsuranceExpiryDate  && props.mode=='reg_edit' ? props.vehicleInfo.vehicleInsuranceExpiryDate : null,
        vehicleInsuranceFile: props.vehicleInfo.vehicleInsuranceFile   && props.mode=='reg_edit'? props.vehicleInfo.vehicleInsuranceFile : '',
        vehicleFitnessCertExpiryDate: props.vehicleInfo.vehicleFitnessCertExpiryDate   && props.mode=='reg_edit'? props.vehicleInfo.vehicleFitnessCertExpiryDate : null,
        vehicleFitnessCertFile: props.vehicleInfo.vehicleFitnessCertFile  && props.mode=='reg_edit' ? props.vehicleInfo.vehicleFitnessCertFile : '',
        vehiclePermitExpiryDate: props.vehicleInfo.vehiclePermitExpiryDate  && props.mode=='reg_edit' ? props.vehicleInfo.vehiclePermitExpiryDate : null,
        vehiclePermitFile: props.vehicleInfo.vehiclePermitFile  && props.mode=='reg_edit' ? props.vehicleInfo.vehiclePermitFile : '',
        vehicleRCNo: props.vehicleInfo.vehicleRCNo   && props.mode=='reg_edit'? props.vehicleInfo.vehicleRCNo : '',
        vehicleRCNoExpiryDate: props.vehicleInfo.vehicleRCNoExpiryDate  && props.mode=='reg_edit' ? props.vehicleInfo.vehicleRCNoExpiryDate : null,
        vehicleRoadTaxValidityDate: props.vehicleInfo.vehicleRoadTaxValidityDate  && props.mode=='reg_edit' ? props.vehicleInfo.vehicleRoadTaxValidityDate : null,
        id: props.vehicleInfo.id
      }
    },
    validationSchema: Yup.object().shape({
      vehicleNumber: Yup.string().matches('^[A-Za-z]{2}[0-9]{2}(?:[A-Za-z])?(?:[A-Za-z]{2,3})?[0-9]{4}$', 'Please enter a valid Vehicle number').required('Vehicle Number Required'),
      vehiclePUCFile: Yup.string().required('Required'),
      vehicleInsuranceFile: Yup.string().required('Required'),
      vehicleTypeId: Yup.string().required('Required'),
    }),
    handleSubmit(values, { props, resetForm }) {
      let timezone = localStorage.getItem("timezone");
      let puc, vehiclePUCFile;
      if(typeof(values.vehiclePUCFile)=='object'){
        puc = values.vehiclePUCFile ? values.vehiclePUCFile.base64.split(',') : null
        vehiclePUCFile = puc ? puc[1] : null
      }else{
        vehiclePUCFile = values.vehiclePUCFile
      }
      let insurance, vehicleInsuranceFile
      if(typeof(values.vehicleInsuranceFile)=='object'){
        insurance = values.vehicleInsuranceFile ? values.vehicleInsuranceFile.base64.split(',') : null
        vehicleInsuranceFile = insurance ? insurance[1] : null
      }else{
        vehicleInsuranceFile = values.vehicleInsuranceFile
      }
      let fitness, vehicleFitnessCertFile
      if(typeof(values.vehicleFitnessCertFile)=='object'){
        fitness = values.vehicleFitnessCertFile ? values.vehicleFitnessCertFile.base64.split(',') : null
        vehicleFitnessCertFile = fitness ? fitness[1] : null
      }else{
        vehicleFitnessCertFile = values.vehicleFitnessCertFile
      }
      let permit, vehiclePermitFile
      if(typeof(values.vehiclePermitFile)=='object'){
        permit = values.vehiclePermitFile ? values.vehiclePermitFile.base64.split(',') : null
        vehiclePermitFile = permit ? permit[1] : null
      }else{
        vehiclePermitFile = values.vehiclePermitFile
      }
      
      let vehiclePUCExpiryDate = values.vehiclePUCExpiryDate ? moment.tz(values.vehiclePUCExpiryDate, timezone).format('YYYY-MM-DD') : null
      let vehicleInsuranceExpiryDate = values.vehicleInsuranceExpiryDate ? moment.tz(values.vehicleInsuranceExpiryDate, timezone).format('YYYY-MM-DD') : null
      let vehiclePermitExpiryDate = values.vehiclePermitExpiryDate ? moment.tz(values.vehiclePermitExpiryDate, timezone).format('YYYY-MM-DD') : null
      let vehicleFitnessCertExpiryDate = values.vehicleFitnessCertExpiryDate ? moment.tz(values.vehicleFitnessCertExpiryDate, timezone).format('YYYY-MM-DD') : null
      let vehicleRCNoExpiryDate = values.vehicleFitnessCertExpiryDate ? moment.tz(values.vehicleRCNoExpiryDate, timezone).format('YYYY-MM-DD') : null
      let vehicleRoadTaxValidityDate = values.vehicleFitnessCertExpiryDate ? moment.tz(values.vehicleRoadTaxValidityDate, timezone).format('YYYY-MM-DD') : null
      let vehicleTypeId = values.vehicleTypeId ? values.vehicleTypeId : null
      let combineParams = {
        ...values, vehiclePUCFile,
        vehicleInsuranceFile,
        vehicleFitnessCertFile,
        vehiclePermitFile,
        vehiclePUCExpiryDate,
        vehiclePermitExpiryDate,
        vehicleFitnessCertExpiryDate,
        vehicleRCNoExpiryDate,
        vehicleRoadTaxValidityDate,
        vehicleInsuranceExpiryDate,
        vehicleTypeId,
      }
      //console.log('>>>Vehicle>>', combineParams)
      let data = (JSON.stringify(combineParams, null, 2));
      let vehicles = []
      vehicles = JSON.parse(data)
      if (props.mode == 'reg_edit') {
        props.getEditVehicledata(vehicles)
      }
      else {
        props.getvehicledata(vehicles)
      }
      
      submit_form = false
      resetForm({ values: '' })
    }
  })(VehicleDetails)

export default connect(null, {
  successAlertDispatcher,
  errorAlertDispatcher,
})(VehicleModal);
